export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/a005ebef29695e21817671a59d053432.jpg"
          alt="Secure Network Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-20 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-white">
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight mb-6">
              SECURE YOUR<br />DIGITAL LIFE
            </h1>
            <p className="text-lg lg:text-xl text-white/90 mb-10 leading-relaxed">
              Enterprise-grade VPN protection for your privacy and security
            </p>
            <button
              onClick={scrollToContact}
              className="bg-black text-white px-8 py-4 rounded-full text-base font-medium hover:bg-gray-800 transition-all duration-300 flex items-center space-x-3 group whitespace-nowrap cursor-pointer"
            >
              <div className="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center">
                <i className="ri-shield-check-line text-white text-xl"></i>
              </div>
              <span>Start Protecting Now</span>
              <i className="ri-arrow-right-up-line text-xl group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
            </button>
          </div>

          {/* Right Content - Illustration */}
          <div className="hidden lg:block">
            <img
              src="https://readdy.ai/api/search-image?query=Isometric%203D%20illustration%20of%20VPN%20security%20concept%20showing%20multiple%20devices%20laptop%20smartphone%20tablet%20connected%20through%20encrypted%20tunnel%20with%20glowing%20shield%20protection%2C%20floating%20UI%20elements%20displaying%20connection%20status%20and%20location%20pins%2C%20modern%20tech%20illustration%20with%20blue%20and%20orange%20accent%20colors%2C%20clean%20white%20background%2C%20professional%20digital%20security%20visualization&width=800&height=800&seq=hero-illustration-001&orientation=squarish"
              alt="VPN Security Illustration"
              className="w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
